"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _TextInput = _interopRequireDefault(require("../../TextInput/TextInput"));
var _EmailInput = _interopRequireDefault(require("../../EmailInput/EmailInput"));
var _PhoneInput = _interopRequireDefault(require("../../PhoneInput/PhoneInput"));
var _Dropdown = _interopRequireDefault(require("../../Dropdown/Dropdown"));
var _TextArea = _interopRequireDefault(require("../../TextArea/TextArea"));
var _Checkbox = _interopRequireDefault(require("../../Checkbox/Checkbox"));
var _RadioButtons = _interopRequireDefault(require("../../RadioButtons/RadioButtons"));
var _NumberInput = _interopRequireDefault(require("../../NumberInput/NumberInput"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.inForm-container .hidden {\n  display: none; }\n\n.inForm-container .bx--label {\n  color: #4c4c4c; }\n\n.inForm-container .checkbox {\n  margin-bottom: 8px; }\n\n.inForm-container .inform-checkbox {\n  margin-bottom: 42px;\n  margin-top: 42px; }\n";
  const fileName = "InFormInput_InForm";
  const element = document.querySelector("style[data-sass-component='InFormInput_InForm']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const MutipleCheckBox = _ref => {
  let {
    lang,
    field,
    fetchTerms,
    props
  } = _ref;
  const [items, setItems] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    fetchTerms(lang, field.vocabulary, data => {
      setItems(data.map(el => ({
        id: el.id,
        title: el.title
      })));
    });
  }, []);
  const onChange = value => {
    const index = props.value.indexOf(value);
    if (index === -1) {
      props.onChange(null, [...props.value, parseInt(value)]);
    } else {
      props.onChange(null, props.value.filter(el => el != value));
    }
  };
  if (items.length === 0) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, items.map(el => {
    return /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      id: el.id,
      key: parseInt(el.id),
      label: el.title,
      value: props.value.indexOf(parseInt(el.id)) >= 0,
      onChange: () => onChange(parseInt(el.id))
    });
  }), props.invalidText && /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-07 sia-margin-02-bottom"
  }, props.invalidText));
};
const Wrapper = _ref2 => {
  let {
    lang,
    field,
    fetchTerms,
    ...props
  } = _ref2;
  if (field.type === 'textfield') {
    if (!!field.pattern) {
      if (field.pattern.toLowerCase() === 'number') return /*#__PURE__*/_react.default.createElement(_NumberInput.default, props);
      if (field.pattern.toLowerCase() === 'text') return /*#__PURE__*/_react.default.createElement(_TextInput.default, _extends({
        patterns: [/^[\p{L}\s]*$/u]
      }, props));
    }
    return /*#__PURE__*/_react.default.createElement(_TextInput.default, props);
  }
  if (field.type === 'textarea') return /*#__PURE__*/_react.default.createElement(_TextArea.default, props);
  if (field.type === 'webform_term_checkboxes') {
    return /*#__PURE__*/_react.default.createElement(MutipleCheckBox, {
      lang: lang,
      field: field,
      props: props,
      fetchTerms: fetchTerms
    });
  }
  if (field.type === 'tel') return /*#__PURE__*/_react.default.createElement(_PhoneInput.default, _extends({}, props, {
    invalidPatternText: props.translate("form.input.error.invalid.with-example", {
      example: props.translate('form.input.error.invalid.example.phone')
    }),
    onChange: (event, value, error) => {
      props.onChange(event, value, error);
      props.setErrors({
        ...props.errors,
        [field.id]: error
      });
    }
  }));
  if (field.type === 'email') return /*#__PURE__*/_react.default.createElement(_EmailInput.default, _extends({}, props, {
    invalidPatternText: props.translate("form.input.error.invalid.with-example", {
      example: props.translate('form.input.error.invalid.example.email')
    }),
    onChange: (event, value, error) => {
      props.onChange(event, value, error);
      props.setErrors({
        ...props.errors,
        [field.id]: error
      });
    }
  }));
  if (field.type === 'select') return /*#__PURE__*/_react.default.createElement(_Dropdown.default, _extends({
    required: field.required
  }, props));
  if (field.type === 'checkbox') {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "inform-checkbox"
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      id: field.id,
      label: field.label,
      value: !!props.value,
      onChange: props.onChange,
      description: field.description,
      error: props.invalidText
    }));
  }
  if (field.type === 'radios') {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "sia-margin-03-bottom " + props.className
    }, /*#__PURE__*/_react.default.createElement("label", {
      className: "bx--label"
    }, field.label), /*#__PURE__*/_react.default.createElement(_RadioButtons.default, {
      name: field.id,
      items: Object.entries(field.options).map(el => ({
        value: el[0],
        label: [el[1]]
      })),
      onChange: value => {
        props.onChange(value, value);
      }
    }), props.invalidText && /*#__PURE__*/_react.default.createElement("div", {
      class: "radio-error sia-text-07"
    }, props.invalidText));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
const getDefaultValue = (values, field) => {
  if (values && values[field.id]) return values[field.id];
  return field.type === 'select' ? {} : field.type === 'webform_term_checkboxes' ? [] : '';
};
const InformInput = _ref3 => {
  let {
    lang,
    field,
    values,
    setValues,
    errors,
    translate,
    setErrors,
    fetchTerms
  } = _ref3;
  const [value, setValue] = (0, _react.useState)(getDefaultValue(values, field));
  const error = errors[field.id] ? translate(errors[field.id]) : undefined;
  const setInputValue = newValue => {
    setValue(newValue);
    setValues({
      ...values,
      [field.id]: field.type === 'select' ? newValue.id : newValue
    });
  };
  (0, _react.useEffect)(() => {
    if (!values || !values[field?.id]) {
      setValue(getDefaultValue(values, field));
    }
  }, [values]);
  const className = error ? 'error-InformInput' : '';
  if (field.type === 'select' && Object.entries(field.options || {})?.length > 0) {
    const items = Object.entries(field.options).map(option => ({
      id: option[0],
      label: option[1]
    }));
    return /*#__PURE__*/_react.default.createElement("div", {
      className: field?.class?.length > 0 ? field.class[0] : undefined
    }, /*#__PURE__*/_react.default.createElement(Wrapper, {
      className: className,
      field: field,
      id: field.id,
      label: field.label,
      items: items,
      value: value,
      onChange: (event, item) => setInputValue(item),
      invalidText: error,
      setErrors: setErrors
    }));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: field?.class?.length > 0 ? field.class[0] : undefined
  }, /*#__PURE__*/_react.default.createElement(Wrapper, {
    lang: lang,
    className: className,
    field: field,
    id: field.id,
    label: field.label,
    value: value,
    required: !!field.required,
    onChange: (e, value) => {
      setInputValue(value);
    },
    invalidText: error,
    setErrors: setErrors,
    errors: errors,
    translate: translate,
    fetchTerms: fetchTerms
  }));
};
var _default = exports.default = InformInput;